<template>
  <section>
    <v-row>
      <v-col :xs="12" :md="6" :cols="12" class="date-select">
        <p class="primary--text text--darken-1 font-weight-bold">
          <v-icon :x-large="$vuetify.breakpoint.smAndUp" :large="!$vuetify.breakpoint.smAndUp" class="primary--text text--darken-1 mr-4">mdi-calendar</v-icon>
          {{ $t('label.date') }}
        </p>
        <DateSelect v-model="deliveryDate" :availableDates="deliverySlot.date" />
      </v-col>
      <v-col :xs="12" :md="6" :cols="12" class="time-select">
        <p class="primary--text text--darken-1 font-weight-bold">
          <v-icon :x-large="$vuetify.breakpoint.smAndUp" :large="!$vuetify.breakpoint.smAndUp" class="primary--text text--darken-1 mr-4">mdi-clock-outline</v-icon>
          {{ $t('label.time') }}
        </p>
        <DropdownField v-model="deliveryTime" :dropdownOptions="deliverySlot.time" :label="label === $t('label.pickUpDetails') ? $t('label.pickupTime') : $t('label.deliveryTime')" />
      </v-col>
    </v-row>
    <v-row class="mt-4 mx-n2">
      <v-col :cols="12">
        <div class="d-flex justify-space-between align-center mb-2">
          <p class="secondary--text font-weight-bold">{{ label ? label : $t('label.deliveryDetails') }}</p>
          <v-btn
            depressed
            class="primary--text text-capitalize"
            :to="{ name: label === $t('label.pickUpDetails') ? $constants.ROUTE_NAME.ORDER_RETURN_PICKUP_ADDRESS : $constants.ROUTE_NAME.ORDER_ADDRESS_BOOK, params: { isCheckout: isCheckout } }"
          >
            {{ $t('label.edit') }}
          </v-btn>
        </div>
        <div class="py-6 px-4 mb-2 rounded-lg elevation-4">
          <p v-if="isEditCountry" class="text-caption secondary--text text--lighten-2">Country</p>
          <v-select
            v-if="isEditCountry && countryList.length > 0"
            :items="countryList.filter((f) => f.id === currentUser.country_id)"
            hide-details
            single-line
            class="transparent pt-0"
            style="width: 40%"
            item-text="name"
            item-value="id"
            @change="editAddressCountry"
          >
            <template v-slot:append>
              <v-btn fab depressed max-height="25" color="transparent" class="disable-hover-bg" :ripple="false">
                <v-icon color="primary" class="transparent">mdi-chevron-down</v-icon>
              </v-btn>
            </template>
          </v-select>
          <v-divider v-if="isEditCountry" class="my-4" />
          <p class="text-caption secondary--text text--lighten-2">{{ label !== $t('label.pickUpDetails') ? $t('label.receiverName') : $t('label.collectorName') }}</p>
          <p class="font-weight-medium">{{ currentDeliveryAddress.receiver_name }}</p>
          <v-divider class="my-4" />
          <p class="text-caption secondary--text text--lighten-2">{{ label !== $t('label.pickUpDetails') ? $t('label.deliveryAddress') : $t('label.pickupAddress') }}</p>
          <p class="font-weight-medium">{{ currentDeliveryAddress.address }}</p>
          <v-divider class="my-4" />
          <p v-if="label !== $t('label.pickUpDetails')" class="text-caption secondary--text text--lighten-2">{{ $t('label.billingAddress') }}</p>
          <p v-if="label !== $t('label.pickUpDetails')" class="font-weight-medium">
            {{ currentDeliveryAddress.address === currentBillingAddress.address && currentDeliveryAddress.address.length ? $t('label.sameAsDeliveryAddress') : currentBillingAddress.address }}
          </p>
          <v-divider v-if="label !== $t('label.pickUpDetails')" class="my-4" />
          <p class="text-caption secondary--text text--lighten-2">{{ $t('label.contactNo') }}</p>
          <p class="font-weight-medium">
            {{ currentDeliveryAddress.contact_no }}
          </p>
          <v-divider class="my-4" />
        </div>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import DateSelect from '@/components/DateSelect.vue'
import DropdownField from '@/components/fields/DropdownField.vue'
import { PURCHASE } from '@/api/purchase.api'
export default {
  props: {
    isEditCountry: { type: Boolean, default: false },
    label: { type: String, required: false },
    isCheckout: { type: Boolean, default: false }
  },
  components: {
    DateSelect,
    DropdownField
  },
  data() {
    return {
      deliveryDetails: {},
      deliverySlot: {
        date: [],
        time: []
      }
    }
  },
  created() {
    this.addressList.length === 0 && this.getAddress()
  },
  computed: {
    ...mapState('auth', ['addressList', 'currentDeliveryAddress', 'currentBillingAddress', 'currentUser']),
    ...mapState('order', ['arrangeDelivery']),
    ...mapState('common', ['countryList']),
    deliveryDate: {
      get() {
        return this.arrangeDelivery.date
      },
      async set(value) {
        this.deliverySlot = await PURCHASE.getDeliverySlot(value)
        this.setArrangeDelivery({ date: value })
      }
    },
    deliveryTime: {
      get() {
        return this.arrangeDelivery.time
      },
      set(value) {
        this.setArrangeDelivery({ time: value })
      }
    }
  },

  methods: {
    ...mapActions('auth', ['getAddress', 'editAddressCountry']),
    ...mapMutations('order', ['setArrangeDelivery'])
  }
}
</script>

<style></style>
